/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_Summary_PaidInputs */

const cs_deal_payments_summary_paid = /** @type {(inputs: Deal_Payments_Summary_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaplacené`)
};

const en_deal_payments_summary_paid = /** @type {(inputs: Deal_Payments_Summary_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Deal_Payments_Summary_PaidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_summary_paid = /** @type {((inputs?: Deal_Payments_Summary_PaidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_Summary_PaidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_summary_paid(inputs)
	return cs_deal_payments_summary_paid(inputs)
});